import React, { Component } from 'react'
import { compose, withApollo } from 'react-apollo'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  NavLink
} from 'react-router-dom'
import { Dropdown, Layout, Menu, Icon, Avatar, Row, Col, message } from 'antd'
import Login from './Login'
import Dashboard from './Dashboard'
import Account from './Account'
import ProductFeature from './ProductFeature'
import CreateBrand from './CreateBrand'
import ValidateBrand from './ValidateBrand'
import WrappedBrandProfile from './BrandProfile'
import BrandNews from './BrandNews'
import BrandCover from './BrandCover'
import BrandProduct from './BrandProduct'
import BrandMaterial from './BrandMaterial'
import BrandSetting from './BrandSetting'
import BrandHero from './BrandHero'
import BrandActivity from './BrandActivity'
import { styles, MenuWrapper, Font, Centered } from './styles'
const { Header, Sider, Content } = Layout
const logo = require('../assets/images/logo-inverse.png')
const g2gLogo = require('../assets/images/g2g.png')

export class App extends Component {
  constructor() {
    super()

    this.state = {
      collapsed: false,
      defaultBrand: 0
    }

    this.toggle = this.toggle.bind(this)
    this.logout = this.logout.bind(this)
    this.menu = this.menu.bind(this)
  }

  toggle() {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed
    }))
  }

  toggleBrand(key) {
    this.setState({
      defaultBrand: key,
    })
  }

  logout() {
    const { client } = this.props
    localStorage.removeItem('user-token')
    localStorage.removeItem("data");
    localStorage.removeItem("new_Brand");
    window.location.href = "/"
    client.resetStore()
  }

  menu() {
    return (
      <Menu>
        <Menu.Item>
          <NavLink to="/account">
            <Icon type="user" style={{ marginRight: '8px' }} />
            Account
          </NavLink>
        </Menu.Item>
        <Menu.Item onClick={() => this.logout()}>
          <Icon type="poweroff" />
          Logout
        </Menu.Item>
      </Menu>
    )
  }

  render() {
    const { collapsed, defaultBrand } = this.state
    const data = JSON.parse(localStorage.getItem('data'));
    const new_Brand = JSON.parse(localStorage.getItem('new_Brand'));

    const menu =
      (
        <Menu>
          {data && data.brand.map((brand, idx) => {
            return (
              <Menu.Item key={idx} onClick={(e) => this.toggleBrand(e.key)}>
                <Avatar
                  src={brand.logo}
                  style={{ padding: '2px' }}
                />
                {brand.name}
              </Menu.Item>
            )

          })}
          <Menu.Item>
            <NavLink to="/create-brand">
              <Icon type="plus" />
              <span style={{ padding: '2px' }}>เพิ่ม Brand</span>
            </NavLink>
          </Menu.Item>
        </Menu>
      );

    return (
      <Router>
        {data ? (
          <Layout style={{ minHeight: '100vh' }}>
            {data.brand[defaultBrand] ? (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={250}>
                {collapsed ? (
                  <Avatar src={data.brand[defaultBrand].logo} size={48} />
                ) : (
                  <div style={{
                    position: 'relative',
                    background: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}>
                    <br></br>
                    <NavLink to="/">
                      <h1 >สวัสดี!</h1>
                    </NavLink>
                    <Row gutter={16} type="flex" justify="center" align="middle">
                      <NavLink to="/">
                        <Avatar src={data.brand[defaultBrand].logo} size={48} />
                      </NavLink>
                    </Row>
                    <br></br>
                    <Row gutter={16} type="flex" justify="center" align="middle">
                      <Dropdown.Button overlay={menu} icon={<Icon type="user" />} trigger={['click']}>
                        <Font>{data.brand[defaultBrand].name}</Font>
                      </Dropdown.Button>
                    </Row>
                    <br></br>
                  </div>
                )}
                {data.brand[defaultBrand].status == "APPROVED" ? (
                  <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
                    <Menu.Item key="brand-profile">
                      <NavLink to="/brand-profile">
                        <Icon type="user" />
                        <span>Brand Profile</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-news">
                      <NavLink to="/brand-news">
                        <Icon type="sound" />
                        <span>Brand News</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-cover">
                      <NavLink to="/brand-cover">
                        <Icon type="desktop" />
                        <span>Brand Cover</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-product">
                      <NavLink to="/brand-product">
                        <Icon type="rest" />
                        <span>Brand Product</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-material">
                      <NavLink to="/brand-material">
                        <Icon type="database" />
                        <span>Brand Material</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-setting">
                      <NavLink to="/brand-setting">
                        <Icon type="setting" />
                        <span>Brand Setting</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-hero">
                      <NavLink to="/brand-hero">
                        <Icon type="team" />
                        <span>Brand Hero</span>
                      </NavLink>
                    </Menu.Item>
                    <Menu.Item key="brand-activity">
                      <NavLink to="/brand-activity">
                        <Icon type="star" />
                        <span>Brand Activity</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu>
                ) : (
                  <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
                    <Menu.Item key="1">
                      <NavLink to="/validate-brand">
                        <Icon type="user" />
                        <span>ยืนยันตัวตน</span>
                      </NavLink>
                    </Menu.Item>
                  </Menu>
                )}
              </Sider>
            ) : (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                width={250}>
                <div style={{
                  position: 'relative',
                  background: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                  <br></br>
                  <h1>สวัสดี!</h1>
                  <br></br>
                </div>
                {new_Brand == 1 ? (<Menu theme="light" mode="inline">
                  <Menu.Item key="1">
                    <NavLink to="/validate-brand">
                      <Icon type="user" />
                      <span>ยืนยันตัวตน</span>
                    </NavLink>
                  </Menu.Item>
                </Menu>) : (<Menu theme="light" mode="inline">
                  <Menu.Item key="1">
                    <NavLink to="/create-brand">
                      <Icon type="plus" />
                      <span>เพิ่ม Brand แรกของคุณ</span>
                    </NavLink>
                  </Menu.Item>
                </Menu>)}
              </Sider>
            )}
            <Layout>
              <Header style={{ background: '#fff', padding: 0 }}>
                <Icon
                  style={{ padding: '0 24px' }}
                  className="trigger"
                  type={collapsed ? 'menu-unfold' : 'menu-fold'}
                  onClick={this.toggle}
                />
                <MenuWrapper>
                  <Dropdown
                    overlay={this.menu}
                    placement="topRight"
                    trigger={['click']}>
                    <a href="/">
                      <React.Fragment>
                        {data.name}
                        <Avatar
                          src={data.imageUrl}
                          style={{ marginLeft: '8px' }}
                        />
                      </React.Fragment>
                    </a>
                  </Dropdown>
                </MenuWrapper>
              </Header>
              <Content style={styles.content}>
                <Switch>
                  <Route exact path="/" component={Dashboard} />
                  <Route
                    exact
                    path="/create-brand"
                    component={() => <CreateBrand me={data} />}
                  />
                  <Route
                    exact
                    path="/validate-brand"
                    component={() => <ValidateBrand me={data.brand[defaultBrand]} />}
                  />
                  <Route
                    exact
                    path="/brand-profile"
                    component={() => <WrappedBrandProfile me={data.brand[defaultBrand].id} />}
                  />
                  <Route
                    exact
                    path="/brand-news"
                    component={() => <BrandNews brandId={data.brand[defaultBrand].id} />}
                  />
                  <Route
                    exact
                    path="/brand-cover"
                    component={() => <BrandCover brandId={data.brand[defaultBrand].id} />}
                  />
                  <Route
                    exact
                    path="/brand-product"
                    component={() => <BrandProduct brandId={data.brand[defaultBrand].id} />}
                  />
                  <Route
                    exact
                    path="/brand-material"
                    component={() => <BrandMaterial brand={data.brand[defaultBrand]} />}
                  />
                  <Route
                    exact
                    path="/brand-setting"
                    component={() => <BrandSetting brand={data.brand[defaultBrand]} />}
                  />
                  <Route
                    exact
                    path="/brand-hero"
                    component={() => <BrandHero brandId={data.brand[defaultBrand].id} />}
                  />
                  <Route
                    exact
                    path="/brand-activity"
                    component={() => <BrandActivity brandId={data.brand[defaultBrand].id} />}
                  />

                  <Route
                    exact
                    path="/account"
                    render={(props) => <Account {...props} {...this.props} />}
                  />
                </Switch>
              </Content>
            </Layout>
          </Layout>
        ) : (
          <Switch>
            <Route exact path="/" component={Login} />
            <Redirect from="*" to="/" />
          </Switch>
        )}
      </Router>
    )
  }
}

export default compose(withApollo)(App)



// WEBPACK FOOTER //
// ./src/pages/App.js